<template>
  <ModalDefault modal_id="wizardTesterModal"
                v-if="channels && channels.data.length > 0 && channels.data && channels.data[0].id"
                header="y"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :footer="false"
                :modal_header="channels.data[0].type_key === 1 ? 'Conecte seu Telegram!' : 'Conecte seu WhatsApp!'"
                :icon="channels.data[0].type_key === 1 ? 'mr-1 bx bxl-telegram' : `mr-1 bx bx-qr-scan`">
    <div class="px-2 py-2 pb-3" slot="body">
      <!--  Conectar Conta  -->
      <div v-if="true || configs.wizard_step == '99'" class="row px-3 py-3">
        <div v-if="channels.data[0].type_key === 0" class="col-12 d-flex"
             style="justify-content: center; margin-top: -150px; margin-bottom: -150px;">
          <lottie-player src="https://assets10.lottiefiles.com/packages/lf20_vzjElM.json"
                         background="transparent"
                         speed="0.6"
                         style="width: 100%; height: 600px;"
                         loop  autoplay>
          </lottie-player>
        </div>
        <div v-if="channels.data[0].type_key === 1" class="col-12 d-flex"
             style="justify-content: center; margin-top: -80px; margin-bottom: -40px;">
          <lottie-player src="https://assets6.lottiefiles.com/temp/lf20_Pn8REz.json"
                         background="transparent"
                         speed="0.6"
                         style="width: 100%; height: 400px;"
                         loop  autoplay>
          </lottie-player>
        </div>
        <div class="col-12 text-center">
          <h5 class="title-color">
            {{
              channels.data[0].type_key === 1 ? `Você precisa conectar sua conta do Telegram!` : `Você precisa conectar sua conta do WhatsApp!`
            }}
          </h5>
          <span>
             {{ channels.data[0].type_key === 1 ? `Para conversar com seus contatos do Telegram através do nosso CRM, você precisa conectar sua conta nas Configurações do Canal. Clique no botão abaixo para conectar sua conta!` : `Para conversar com seus contatos do WhatsApp através do nosso CRM, você precisa conectar sua conta nas Configurações do Canal. Clique no botão abaixo para conectar sua conta!`}}
          </span>
        </div>
        <div class="col-12 text-center">
          <div class="pt-1">
            <div data-toggle="modal"
                 @click.prevent="goToScan()"
                 class="btn-sm btn btn-success py-2 px-3 shadow-none rounded-0">
              <i v-if="false" class="bx bxs-rocket pr-2"></i>
              <strong style="font-size: 16px;">{{ `Conectar minha conta` }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="px-2 py-2 d-flex">
      <div>
        <span data-dismiss="modal"
              class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3">
          <span class="">{{ getTranslations('expression_541') }}</span>
        </span>
      </div>
      <div v-b-tooltip.top
           :title="getTranslations('expression_702')">
        <span style="cursor: not-allowed;"
              class="shadow-sm animated--grow-in btn-outline-danger py-2 px-3">
          <span class="">{{ getTranslations('expression_679') }}</span>
        </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import $ from "jquery";

export default {
  name: "ModalWizardTester",
  components: {
    ModalDefault,
  },
  methods:{
    setTab(payload){
      this.$root.$emit('setTab', payload)
    },

    goToScan(){
      $('#wizardTesterModal').modal('hide')
      window.localStorage.setItem("channel_id", this.channels.data[0].id)

      setTimeout(() => {
        if (this.$route.name === 'Channel') {
          // Ignora erro de "Navegação duplicada" quando tenta acessar a mesma rota, mas exibe outros erros que possam ocorrer.
          const routeCurrent = this.$route.name;
          this.$router.push({name: routeCurrent}).catch(error => {
            if (error.name !== "NavigationDuplicated") {
              throw error;
            }
          });
        } else {
          this.$router.push({name: 'Channel'})
        }
        setTimeout(() => {
          if (this.channels.data) {
            this.channels.data[0].type_key === 1 ? this.setTab(20) : this.setTab(21)
          }
        }, 200)
      }, 500);
    },

  }



}
</script>

<style scoped>

</style>
